<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-radio-group
            [value]="example.selectedValue"
            aria-label="Options"
        >
            @for (option of example.options; track option.value) {
                <uilab-mat-radio-button [value]="option.value">
                    {{ option.label }}
                </uilab-mat-radio-button>
            }
        </uilab-mat-radio-group>
    </avd-code-example>
}
